import { Document, Page, View, StyleSheet, Text, Font } from "@react-pdf/renderer";
// import imgGaruda from '../../../assets/images/pngwing.png';
import srcArial from '../../../assets/custom/font/arial/arial.ttf'
import srcArialBold from '../../../assets/custom/font/arial/ARIBL0.ttf'

Font.register({ family: 'Arial', src: srcArial })
Font.register({ family: 'Arial-Bold', src: srcArialBold })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 48,
        paddingHorizontal: 42,
        boxSizing: "border-box"
    },
    headingImg: {
        width: 50,
        height: 50,
        marginVertical: 15,
        marginHorizontal: 235,
    },
    headingText: {
        fontSize: 12,
        textAlign: "center",
    },
    table: {
        display: "table",
        width: "auto"
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1
    },
    text: {
        fontSize: 10,
        fontFamily: "Arial",
        textAlign: "justify"
    },
    textBold: {
        fontSize: 12,
        fontFamily: "Arial-Bold"
    }
})

const CetakLampTeknisCDOIB = ({ rowData, lampiranTeknis }) => {
    return (
        <Document>
            <Page size={'A4'} style={styles.page}>
                {/* <View>
                    <Image style={styles.headingImg} src={imgGaruda} />
                    <Text style={[styles.headingText, { fontFamily: 'Arial-Bold', marginBottom: 10, fontSize: 10 }]}>PEMERINTAH REPUBLIK INDONESIA</Text>
                </View>
                <View style={[{ marginBottom: 5 }]}>
                    <Text style={[styles.headingText, { fontFamily: 'Arial-Bold', fontSize: 10 }]}>PERIZINAN BERUSAHA UNTUK MENUNJANG KEGIATAN</Text>
                    <Text style={[styles.headingText, { fontFamily: 'Arial-Bold', fontSize: 10, textTransform: 'uppercase' }]}> USAHA SERTIFIKASI {(rowData.urIzin)}</Text>
                    <Text style={[styles.headingText, { fontFamily: 'Arial-Bold', marginBottom: 20, fontSize: 10 }]}> PB-UMKU:</Text>
                </View> */}
                {/* <View style={[{ marginTop: 200, marginBottom: 20 }]}>
                    <Text style={[styles.text, { fontSize: 10 }]}>Lampiran berikut memuat data teknis {rowData.namaIzin}</Text>
                </View> */}
                <View style={[{ marginTop: 200, marginBottom: 20 }]}>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: '33%' ,padding:0.5 }]}>
                                <Text style={[styles.text, { fontSize: 10 }]}>Lampiran berikut memuat data teknis </Text>
                            </View>
                            <View style={[styles.tableCol, { width: '67%', padding:0 }]}>
                                <Text style={[styles.text, { fontFamily: 'Arial-Bold', fontSize: 9 }]}>{rowData.namaIzin}</Text>
                            </View>
                        </View>
                    </View>
                </View>
                <View style={[{ marginBottom: 10 }]}>
                    <Text style={[styles.text, { fontSize: 10 }]}>Berdasarkan Peraturan Menteri Kelautan dan Perikanan Nomor 10 Tahun 2021 Tentang Standar Kegiatan Usaha dan Produk Pada Penyelenggaraan Perizinan Berusaha Berbasis Resiko sektor Kelautan dan Perikanan, menetapkan bahwa: </Text>
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '2%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>1. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Nomor Referensi Teknis </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>: </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '55%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{lampiranTeknis.nomorReferensiTeknis}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '2%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>2. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Kategori</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>: </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '55%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>{lampiranTeknis.kategori}</Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: '2%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>3. </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '40%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>Masa Berlaku Sertifikat</Text>
                        </View>
                        <View style={[styles.tableCol, { width: '3%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>: </Text>
                        </View>
                        <View style={[styles.tableCol, { width: '55%' }]}>
                            <Text style={[styles.text, { fontSize: 10, textAlign: 'left' }]}>4 (empat) tahun sejak diterbitkan</Text>
                        </View>
                    </View>
                </View>
                <View style={[{ marginBottom: 10 }]}>
                    <Text style={[styles.text, { fontSize: 10 }]}>Fasilitas Distribusi Obat Ikan ini telah menerapkan dan memenuhi persyaratan {rowData.urIzin} sesuai dengan ketentuan peraturan perundang-undangan</Text>
                </View>
                <View>
                    <Text style={[styles.text, { fontSize: 10 }]}>Lampiran Perizinan Berusaha Untuk Menunjang Kegiatan Usaha ini memuat data teknis yang merupakan bagian tidak terpisahkan dari dokumen ini. Pelaku Usaha tersebut di atas wajib menjalankan kegiatan usahanya sesuai dengan ketentuan peraturan perundang-undangan yang berlaku.</Text>
                </View>
            </Page>
        </Document>
    )
}

export default CetakLampTeknisCDOIB